import { __assign, __extends, __rest } from "tslib";
import React from 'react';
import cx from 'classnames';
import bcx from 'bem-classname';
var componentClass = 'btn';
var Button = (function (_super) {
    __extends(Button, _super);
    function Button() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Button.prototype.render = function () {
        var _a;
        var _b = this.props, _c = _b.type, type = _c === void 0 ? 'button' : _c, _d = _b.component, Component = _d === void 0 ? 'button' : _d, _e = _b.variant, variant = _e === void 0 ? 'primary' : _e, _f = _b.size, size = _f === void 0 ? 'regular' : _f, _g = _b.disabled, disabled = _g === void 0 ? false : _g, _h = _b.block, block = _h === void 0 ? false : _h, _j = _b.icon, icon = _j === void 0 ? null : _j, _k = _b.loading, loading = _k === void 0 ? false : _k, _l = _b.placeholder, placeholder = _l === void 0 ? false : _l, innerRef = _b.innerRef, className = _b.className, isExpanded = _b.isExpanded, children = _b.children, otherProps = __rest(_b, ["type", "component", "variant", "size", "disabled", "block", "icon", "loading", "placeholder", "innerRef", "className", "isExpanded", "children"]);
        var classes = cx(bcx(componentClass, (_a = {},
            _a[variant] = placeholder ? false : variant.split('-')[0],
            _a.small = size === 'small',
            _a.disabled = disabled,
            _a.block = block,
            _a.placeholder = placeholder,
            _a)), className);
        var isButton = Component === 'button';
        var variantBody = children;
        if (variant === 'select') {
            variantBody = (React.createElement("div", { className: cx({
                    'btn-select--expanded': isExpanded,
                    'btn-select--non-expanded': !isExpanded,
                }) }, children));
        }
        else if (variant.endsWith('-icon-before')) {
            variantBody = (React.createElement("div", { className: cx('d-flex flex-row justify-content-center align-items-center ', {
                    'flex-gap-12': size !== 'small',
                    'flex-gap-8': size === 'small',
                }) },
                React.createElement("div", null, icon),
                React.createElement("div", null, children)));
        }
        else if (variant.endsWith('-icon-after')) {
            variantBody = (React.createElement("div", { className: cx('d-flex flex-row justify-content-center align-items-center ', {
                    'flex-gap-12': size !== 'small',
                    'flex-gap-8': size === 'small',
                }) },
                React.createElement("div", null, children),
                React.createElement("div", null, icon)));
        }
        return (React.createElement(Component, __assign({ ref: innerRef, className: classes, disabled: disabled }, (isButton && {
            type: type,
        }), { "data-loading": loading, "aria-expanded": variant === 'select' && isExpanded }, otherProps), variantBody));
    };
    return Button;
}(React.Component));
var ButtonRef = React.forwardRef(function (props, ref) { return React.createElement(Button, __assign({}, props, { innerRef: ref })); });
ButtonRef.displayName = 'Button';
export { ButtonRef as Button };
//# sourceMappingURL=Button.js.map